import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const TestManagementLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./test-management-page'),
});
